import { useCallback, useState } from 'react';

import { useAppSelector } from '@/store/hooks';
import { leggiBooleano, scriviBooleano, storageDelDispositivo } from '@/lib/tavolo/preferenze';
import type { Lettura } from '@/lib/tavolo/preferenze';

/**
 * Le DUE impostazioni del tavolo del Chinese Poker (fase 2, Luca I-761/I-763/I-765/I-766): i QUATTRO COLORI dei semi e la VIBRAZIONE. Sono preferenze del SOLO
 * Chinese Poker (per gioco: nessun altro gioco le legge o le cambia) e le ricorda il DISPOSITIVO, non il server. Stesso schema di `useImpostazioniTavolo` del Burraco.
 *  - Quattro colori: spento di default (due colori, rosso e nero, come prima: chi non apre le impostazioni non vede nessun cambio).
 *  - Vibrazione (I-765, «v1»): parte dal valore attuale di `settings.hapticsEnabled` (`useHaptics.ts`) e da li si cambia SOLO qui, senza toccare gli altri giochi.
 *    Finche' chi gioca non sceglie, SEGUE il telefono: nessun valore e scritto. Una volta scelta, la scelta del Chinese Poker vale e basta.
 * ⚠️ Le chiavi non si rinominano: azzererebbero la scelta di chi l'ha fatta.
 */
export const CHIAVE_CP_QUATTRO_COLORI = 'qlash.chinesepoker.quattroColori';
export const CHIAVE_CP_VIBRAZIONE = 'qlash.chinesepoker.vibrazione';

export const leggiQuattroColoriCp = (storage: Lettura): boolean => leggiBooleano(storage, CHIAVE_CP_QUATTRO_COLORI, false);

/** `null` = nessuna scelta fatta (assente, illeggibile, uno storage che lancia): la vibrazione segue il telefono. */
export function leggiVibrazioneCp(storage: Lettura): boolean | null {
  try {
    const raw = storage?.getItem(CHIAVE_CP_VIBRAZIONE);
    return raw === 'true' ? true : raw === 'false' ? false : null;
  } catch {
    return null;
  }
}

export function useImpostazioniCp() {
  const globale = useAppSelector((st) => st.settings.hapticsEnabled);
  const [quattroColori, setQuattroColori] = useState<boolean>(() => leggiQuattroColoriCp(storageDelDispositivo()));
  const [scelta, setScelta] = useState<boolean | null>(() => leggiVibrazioneCp(storageDelDispositivo()));
  const impostaQuattroColori = useCallback((valore: boolean) => {
    scriviBooleano(storageDelDispositivo(), CHIAVE_CP_QUATTRO_COLORI, valore);
    setQuattroColori(valore);
  }, []);
  const impostaVibrazione = useCallback((valore: boolean) => {
    scriviBooleano(storageDelDispositivo(), CHIAVE_CP_VIBRAZIONE, valore);
    setScelta(valore);
  }, []);
  return { quattroColori, vibrazione: scelta ?? globale === true, vibrazioneSceltaDaMe: scelta !== null, impostaQuattroColori, impostaVibrazione };
}
